import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import {
  LeaderboardResponse,
  LeaderboardQueryParams,
} from 'types/interfaces/leaderboard';

export const leaderboardApi = createApi({
  reducerPath: 'leaderboardApi',
  baseQuery: baseQuery,
  tagTypes: ['Leaderboard'],
  endpoints: (builder) => ({
    // Get leaderboard data (public endpoint)
    getLeaderboard: builder.query<LeaderboardResponse, LeaderboardQueryParams>({
      query: ({ category, period, country, search, page = 1, limit = 25, minWantListCount }) => {
        const params = new URLSearchParams();
        params.append('category', category);
        params.append('period', period);
        params.append('page', String(page));
        params.append('limit', String(limit));
        if (country) params.append('country', country);
        if (search) params.append('search', encodeURIComponent(search));
        if (minWantListCount !== undefined) params.append('minWantListCount', String(minWantListCount));

        return {
          url: `/leaderboard?${params.toString()}`,
          method: 'GET',
          requiresAuth: false,
        };
      },
      providesTags: (_result, _error, { category, period }) => [
        { type: 'Leaderboard', id: `${category}-${period}` },
      ],
    }),
  }),
});

export const { useGetLeaderboardQuery } = leaderboardApi;
